import axios from 'axios'

// const instance = axios.create({
//   baseURL: 'https://some-domain.com/api/',
//   timeout: 1000,
//   headers: {'X-Custom-Header': 'foobar'},
//   auth: {
//     username: `${process.env.USERNAME}`,
//     password: `${process.env.PASSWORD}`,
//   }
// });

const getCat = async (category) => {
  const { data } = await axios.get(`${process.env.API}/categories/${category}`)
  return data.name
}

const getFeaturedImg = async (id) => {
  //Il faut mettre l'id de l'image par defaut
  if (!id || id == 0) id = 151

  const { data } = await axios.get(`${process.env.API}/media/${id}`)
  // const { data } = await axios({
  //   method: 'get',
  //   url: `${process.env.SGTMAPI}/proxy`,
  //   params: {
  //     endpoint: 'media',
  //     id: id,
  //   },
  // })
  return data.source_url
}

const getClient = async (id) => {
  const { data } = await axios.get(`${process.env.API}/clients/${id}`)
  return data.title.rendered
}

const getTerm = async (id) => {
  const { data } = await axios.get(`${process.env.API}/project_cat/${id}`)
  return data.name
}

const getDocTerm = async (id) => {
  const { data } = await axios.get(`${process.env.API}/document_cat/${id}`)
  return data.name
}

const getFile = async (id) => {
  const { data } = await axios.get(`${process.env.API}/media/${id}`)
  // console.log(data)
  return {
    link: data.source_url,
    type: data.mime_type,
    size: data.media_details.filesize,
  }
}

const getDocURL = async (endpoint, id, password) => {
  let data = ''

  try {
    data = await axios.get(`${process.env.API}/${endpoint}/${id}?password=${password}`)
  } catch (error) {
    if (error.response) {
      data = error.response.status
      console.clear()
      // console.error(error.response.status,error.response.data.message)
    }
  }
  return data
}

const getEmbeddedFeaturedImg = async (data) => {
  // console.log(data["wp:featuredmedia"])
  if (!data || !data['wp:featuredmedia'].length) {
    return `${process.env.SITE}/wp-content/themes/sgtm/img/default.jpg`
  } else {
    return data['wp:featuredmedia'][0].source_url
  }
}

const getEmbeddedTerm = (data) =>
  ((data && data['wp:term']?.[0]) || []).map((cat) => cat.name).join(', ')

const getEmbeddedACF = async (data) => data['acf:post'][0].title.rendered

const getEmbeddedPost = async (data, id) => {
  //retrieve post title by id
  let post = data['acf:post'].filter((post) => post.id == id)
  return post[0].title.rendered
}

const getEmbeddedGallery = async (data, ids) => {
  //filter attachement by ids
  const gallery = data['acf:attachment'].filter((attachment) => ids.includes(attachment.id))
  return gallery.map((img) => img.source_url)
}

export {
  getCat,
  getFeaturedImg,
  getClient,
  getTerm,
  getDocTerm,
  getFile,
  getDocURL,
  getEmbeddedFeaturedImg,
  getEmbeddedTerm,
  getEmbeddedACF,
  getEmbeddedPost,
  getEmbeddedGallery,
}
